import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import MovieCollection from './components/MovieCollection';
import MovieDetails from './components/MovieDetails';
import { BrowserRouter, Routes, Route } from "react-router-dom"

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/movies" element={<MovieCollection />}/>
      <Route path="/movies/:movieTitle" element={<MovieDetails />}/>

      {/* The "*" has special meaning here. It will match only when no other routes do. */}
      <Route 
        path="*"
        element={<h1>The page you're lookiong for can't be found.</h1>}
      />
    </Routes>
    <footer className="footer extra-dark-background-color">
      <span className="footer-text"><a href="https://alexpaul.dev">© 2022 alexpaul. All Rights Reserved</a></span>
    </footer>
  </BrowserRouter>,
  document.getElementById('root')
);
